<div
  class="headerWrapper"
>
  <div
    class="ratingsTopContainer"
  >

    <div
      class="ratingsCaptionAndButton"
    >

      <div
        class="ratingsCaption"
      >
        <div>
          <img src="/static/img/raitingsIcon.svg">
        </div>
        <div
          class="ratingsCaptionLabel"
        >
          Рейтинги
        </div>
      </div>

      <div>
        <button
          *ngIf="ratingCreateButtonIsAvailable()"
          id="createRating"
          class="btn btn-log btn-lg ratingsCreateButton"
          (click)="createRatingRedirector()"
        >
          СОЗДАТЬ РЕЙТИНГ
        </button>
      </div>
    </div>

    <div class="inputGroup">
      <div class="input-group">
        <div class="inputGroupPrepend">
          <i class="bi bi-search input-group-text searchIcon"></i>
        </div>
        <input
          id="ratingsSearchId"
          type="text"
          name="query"
          id="query"
          class="form-control inputField"
          placeholder="Поиск"
        />
      </div>
    </div>

  </div>

  <div
    class="ratingsBottomContainer"
    *ngIf="labelsOptionsAndHandlers.length"
  >
    <div
      *ngFor="let singleSelectPars of labelsOptionsAndHandlers; index as i"
      class="singleFilterSection"
    >
      <app-custom-select
        [wholeElementId]="'FilterItem' + i"
        [labelText]="singleSelectPars.label"
        [optionsList]="singleSelectPars.optionsList"
        [optionTransformer]="singleSelectPars.optionTransformer"
        [(selectedOption)]="singleSelectPars.selectedOption"
      ></app-custom-select>
    </div>
  </div>
</div>
